import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M1.25 2.5c0-1.367 1.094-2.5 2.5-2.5H10c1.367 0 2.5 1.133 2.5 2.5V10h.313c1.874 0 3.437 1.563 3.437 3.438v1.25c0 .546.39.937.938.937.507 0 .937-.39.937-.937V8.672A2.475 2.475 0 0 1 16.25 6.25v-2.5L15 2.5c-.352-.312-.352-.898 0-1.25.313-.312.898-.312 1.25 0l3.008 3.047c.469.469.742 1.094.742 1.758v8.633a2.826 2.826 0 0 1-2.812 2.812 2.8 2.8 0 0 1-2.813-2.812v-1.25c0-.86-.703-1.563-1.562-1.563H12.5V17.5c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25H1.25C.547 20 0 19.453 0 18.75c0-.664.547-1.25 1.25-1.25zm2.5 4.375c0 .352.273.625.625.625h5A.64.64 0 0 0 10 6.875v-3.75c0-.312-.312-.625-.625-.625h-5a.64.64 0 0 0-.625.625z"
    }, null, -1)
  ])))
}
export default { render: render }